import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { discoveryActions as myActions, alertActions, breadcrumbsActions } from '../../../_services/essentials/store';
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { history } from "../../../_services/essentials/helpers";
import { TextField, Button, Stack, Box, FormControl, Link } from '@mui/material';
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import {
    OutlinedInput,
    InputLabel,
    MenuItem,
    Select,
    Chip
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
// import CheckIcon from "@mui/icons-material/Check";
// import TuneIcon from "@mui/icons-material/Tune";
// import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import IconButton from '@mui/material/IconButton';

export { DiscoveryWizard };

function DiscoveryWizard() {
    //    const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();
    const entity =  useSelector(x => x.discovery?.filter);

    const validationSchema = Yup.object().shape({});
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, reset } = useForm(formOptions);

    const [filterModifiedFlag, setFilterModifiedFlag] = useState(false);

    let allContinentsInMemory = null;
//alert('entity: '+JSON.stringify(entity));

    dispatch(breadcrumbsActions.setCurrentURL({
        url: history.location?.pathname,
        state: history.location?.state
    }));

    useEffect(() => {
        dispatch(breadcrumbsActions.setCurrentTitle(`Discovery`));
        dispatch(myActions.getAllSpecialities()).unwrap();
        dispatch(myActions.getAllContinents()).unwrap();
        dispatch(myActions.getAllSearchTerms()).unwrap();
        dispatch(myActions.getAllProfessionalActivities()).unwrap();
        dispatch(myActions.getAllProfileCompletenessOptions()).unwrap();

    }, [dispatch]);

    async function resetDiscoveryFilter() {
        dispatch(myActions.getAllSpecialities()).unwrap();
        dispatch(myActions.getAllContinents()).unwrap();
        dispatch(myActions.getAllSearchTerms()).unwrap();
        dispatch(myActions.getAllProfessionalActivities()).unwrap();
        dispatch(myActions.getAllProfileCompletenessOptions()).unwrap();
    }

    async function skipDiscoveryFilter() {
        history.navigate(`/discovery/identified_profiles`, { state: { discovery_filter: null }, show_discovery_filter: false });
    }

    // async function ApplyFilter(){
    //     const data = entity;
    //     dispatch(alertActions.clear());
    //     try {
    //         await dispatch(myActions.setFilter(data)).unwrap();
    //         history.navigate(`/discovery/identified_profiles`, { state: { discovery_filter: data, show_discovery_filter: true } });
    //         //dispatch(alertActions.success({ message, showAfterRedirect: true }));
    //     } catch (error) {
    //         //alert(error);
    //         dispatch(alertActions.error(error));
    //     }
    // }

    async function onSubmit(data) {
        // alert(1);
        //alert('data: '+JSON.stringify(data));
        const filteredData = {
            specialities: entity.specialities.value,
            continents: entity.continents.value,
            search_terms: entity.search_terms.value,
            professional_activities: entity.professional_activities.value,
            profile_completeness_options: entity.profile_completeness_options.value
        };
        dispatch(alertActions.clear());
        try {
           await dispatch(myActions.setFilter(filteredData)).unwrap();
           history.navigate(`/discovery/identified_profiles`, { state: { discovery_filter: filteredData, show_discovery_filter: true } });
            //dispatch(alertActions.success({ message, showAfterRedirect: true }));
        } catch (error) {
            //alert(error);
            dispatch(alertActions.error(error));
        }
    }

    const CreateProjectPopupStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // width: uxscreen.size10,
        // width: '50%',
        bgcolor: 'background.modal',
        // border: '2px solid #000',
        boxShadow: 24,
        borderRadius: '25px',
    };

    async function handleCountrySelection (continentId, countryId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);
        const allCountriesFromSelectedContinent = continentObjectWithSelectedContinent[0].countries;
        let countryObject = allCountriesFromSelectedContinent.filter(item => item.id === countryId)[0];

        countryObject = {
            ...countryObject,
            selected: selectionFlag
        };

        let allUpdatedCountriesFromSelectedContinent = [];

        await allCountriesFromSelectedContinent.map(country => {
            if(country.id === countryId) {
                allUpdatedCountriesFromSelectedContinent.push(countryObject);
            } else {
                allUpdatedCountriesFromSelectedContinent.push(country);
            }
        });

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(
                    {
                        ...continent,
                        countries: allUpdatedCountriesFromSelectedContinent
                    });
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        allContinentsInMemory = allUpdatedContinents;
    }

    async function renderUpdatedCountrySelectionList() {

        if (allContinentsInMemory) {
            await dispatch(myActions.updateContinentFilter(allContinentsInMemory)).unwrap();
            allContinentsInMemory = null;
        }
    }

    async function setShowCountryfilterByContinentId (continentId, selectionFlag){
        const allContinents = entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId)[0];

        continentObjectWithSelectedContinent = {
            ...continentObjectWithSelectedContinent,
            showCountryFilter: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObjectWithSelectedContinent);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        //allContinentsInMemory = allUpdatedContinents;
        dispatch(myActions.updateContinentFilter(allUpdatedContinents)).unwrap();

    }

    async function handleContinentSelection (continentId, selectionFlag){
        const allContinents = allContinentsInMemory ? allContinentsInMemory : entity.continents.value;
        let continentObjectWithSelectedContinent = allContinents.filter(item => item.id === continentId);

        let continentObject = continentObjectWithSelectedContinent[0];

        continentObject = {
            ...continentObject,
            selected: selectionFlag
        };

        let allUpdatedContinents = [];

        await allContinents.map(continent => {
            if(continent.id === continentId) {
                allUpdatedContinents.push(continentObject);
            } else {
                allUpdatedContinents.push(continent);
            }
        });

        await dispatch(myActions.updateContinentFilter(allUpdatedContinents)).unwrap();
    }

    async function handleSpecialitiesSelection (specialityId, selectionFlag){
        const allSpecialities = entity.specialities.value;
        let selectedSpecialityObject = allSpecialities.filter(item => item.id === specialityId);

        let specialityObject = selectedSpecialityObject[0];

        specialityObject = {
            ...specialityObject,
            selected: selectionFlag
        };

        let allUpdatedSpecialities = [];

        await allSpecialities.map(speciality => {
            if(speciality.id === specialityId) {
                allUpdatedSpecialities.push(specialityObject);
            } else {
                allUpdatedSpecialities.push(speciality);
            }
        });

        await dispatch(myActions.updateSpecialityFilter(allUpdatedSpecialities)).unwrap();
    }

    async function handleKeywordSearchTerm (e){
        const newSearchTerm = e.target.value;
        await dispatch(myActions.updateSearchTerm(newSearchTerm)).unwrap();
    }

    return (
        <React.Fragment>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={true}
                onClose={() => skipDiscoveryFilter}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 0,
                    },
                }}
            >
                {/*<Fade in={false}>*/}
                <Box sx={CreateProjectPopupStyle}>
                    <Stack direction="column" sx={{ flexGrow: '1', justifyContent: 'space-between', gap: 1 }}>

                        <form name="filterForm" id="filterForm" onSubmit={handleSubmit(onSubmit)}>
                            <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                sx={{
                                    position: "relative",
                                    mt: 3,
                                    mb: 2
                                }}
                            >
                                {/* Logo/Image */}
                                {/*<Box*/}
                                {/*    component="img"*/}
                                {/*    src="/assets/images/healthcare/doc.png"*/}

                                {/*    sx={{ ustifyContent: 'center' }}*/}

                                {/*/>*/}


                                <Link onClick={() => skipDiscoveryFilter()} variant="outlined" color="secondary"
                                      sx={{
                                          position: "absolute",
                                          //top: "1px",
                                          right: "28px",
                                          color: 'background.paper',
                                          cursor: 'pointer'
                                      }}
                                >
                                    Skip
                                    <SkipNextIcon sx={{ ml: 0.5, color: 'background.paper' }} />
                                </Link>
                            </Stack>

                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 0, ml: 2, mt: 1 }}>
                                {!(entity?.specialities?.value?.loading || entity?.value?.specialities.value?.error) &&
                                <FormControl>
                                    <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 2, ml: 2 }}>
                                        <Stack sx={{ flexGrow: '1' }}>
                                            {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                            <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16, color: 'background.paper' }}>

                                                KOLs Speciality
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" sx={{ flexGrow: '1', flexWrap: 'wrap' }}>
                                            {entity?.specialities?.value?.map(({ id, name, display_name, selected }, index) => (
                                                <Box key={id}>
                                                    {/*<TextField key={`${id}-speciality`} hidden={true} id={`id`} name={"id"} value={id} {...register(`specialities.${index}.id`)} />*/}
                                                    {/*<TextField key={`${id}-${name}-speciality`} hidden={true} id={`name`} name={"name"} value={name} {...register(`specialities.${index}.name`)} />*/}
                                                    {/*<TextField key={`${id}-display-${display_name}-speciality`} hidden={true} id={`display_name`} name={"display_name"} value={display_name} {...register(`specialities.${index}.display_name`)} />*/}
                                                    <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                        borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,
                                                    }} defaultChecked={selected} {...register(`specialities.${index}.selected`)} />} key={index} label={display_name} onClick={() => { handleSpecialitiesSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Stack>
                                </FormControl>
                                }
                            </Stack>

                            <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 0, ml: 2, mt: 1 }}>
                                {!(entity?.continents?.value?.loading || entity?.continents?.value?.error) &&
                                <FormControl>
                                    <Stack direction="column" sx={{ flexGrow: '1', gap: 1, mb: 2, ml: 2 }}>
                                        <Stack sx={{ flexGrow: '1' }}>
                                            {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                            <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16, color: 'background.paper' }}>

                                                Preferred geographic locations of the KOLs
                                            </Typography>
                                        </Stack>
                                        <Stack direction="row" sx={{ flexGrow: '1', flexWrap: 'wrap' }}>
                                            {entity?.continents?.value?.map(({ id, name, selected, showCountryFilter, countries, hidden }, index) => (
                                                <Box key={`${id}-continents}`} >
                                                    <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                        borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0, mt: 1
                                                    }} defaultChecked={selected} {...register(`continents.${index}.selected`)} />} hidden={hidden} key={id} label={name} onClick={() => { handleContinentSelection(id, !selected); setFilterModifiedFlag(true);}} />
                                                    {!hidden && !showCountryFilter && countries.length > 0 &&
                                                    <IconButton color="primary" size={"small"} sx={{mt:0, ml: -1, mr: 3, border: 0}} aria-label="add to shopping cart" onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                        <KeyboardArrowRightIcon />
                                                    </IconButton>
                                                    }
                                                    {!hidden && showCountryFilter && countries.length > 0 &&
                                                    <FormControl key={`${id}-geographic-country`} sx={{ mt:0, width: 400,}}>
                                                        <InputLabel>{name}</InputLabel>
                                                        <Select
                                                            id={"countries"}
                                                            name={"countries"}
                                                            key={`${id}--select-geographic-country`}
                                                            multiple
                                                            value={countries}
                                                            sx={{display: "flex",
                                                                flexDirection: "row",
                                                                // height: 'px',
                                                                overflow: "hidden",
                                                                overflowY: "auto",
                                                                border: 0,
                                                            }}
                                                            input={<OutlinedInput label="Multiple Select" />}
                                                            onClose={()=> renderUpdatedCountrySelectionList()}
                                                            renderValue={(countries) => (
                                                                <Stack gap={0.5} direction="row" flexWrap="wrap"
                                                                       sx={{height: '100%',}}
                                                                    // sx={{display: "flex",
                                                                    //     flexDirection: "row",
                                                                    //      height: '25px',
                                                                    //     // overflow: "hidden",
                                                                    //     overflowX: "scroll"}}

                                                                >
                                                                    {countries?.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                                        <Box key={`${id}-countries1}`} >
                                                                            {country_selected &&
                                                                            <Chip
                                                                                key={country_id}
                                                                                label={country_name}
                                                                                onDelete={async () => {
                                                                                    await handleCountrySelection(id, country_id, !country_selected);
                                                                                    renderUpdatedCountrySelectionList();
                                                                                    //value.selected = true
                                                                                    // setSelectedNames(
                                                                                    //     selectedNames.filter((item) => item !== value)
                                                                                    // )
                                                                                }
                                                                                }
                                                                                sx={{fontSize: '10px'}}
                                                                                deleteIcon={
                                                                                    <CancelIcon
                                                                                        onMouseDown={(event) => event.stopPropagation()}
                                                                                    />
                                                                                }
                                                                            />
                                                                            }
                                                                        </Box>
                                                                    ))}
                                                                </Stack>
                                                            )}
                                                        >
                                                            {countries.map(({ id: country_id, name: country_name, shortName: country_shortName, selected: country_selected }, countryIndex) => (
                                                                <Box key={`${country_id}-countries`} >
                                                                    <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{
                                                                        borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,
                                                                    }} defaultChecked={country_selected} {...register(`continents.${index}.countries.${countryIndex}.selected`)} id={"selected"} name={"selected"} onClick={(e)=> {setTimeout(function(){handleCountrySelection(id, country_id, !country_selected)},100); setFilterModifiedFlag(true);}} />} key={country_id} label={country_name} />
                                                                </Box>
                                                                // <MenuItem
                                                                //     key={country_id}
                                                                //     value={country_name}
                                                                //     onClick={(e)=> {
                                                                //         handleCountrySelection(id, country_id, !country_selected);
                                                                //         setFilterModifiedFlag(true);
                                                                //     }}
                                                                //     sx={{ justifyContent: "space-between" }}
                                                                // >
                                                                //     {country_name}
                                                                //     {country_selected ? <CheckIcon color="info" /> : null}
                                                                // </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                    }
                                                    {!hidden && showCountryFilter && countries.length > 0 &&
                                                    <IconButton color="primary" size={"small"} sx={{ml:1, mt:1, mr: 3, border:0}} onClick={() => setShowCountryfilterByContinentId(id, !showCountryFilter)}>
                                                        <KeyboardArrowLeftIcon />
                                                    </IconButton>
                                                    }
                                                    {/*{countries?.map(({ id, name, shortName, selected }, index) => (*/}
                                                    {/*    <Box key={`${id}-countries}`} sx={{ml:4}}>*/}
                                                    {/*        <TextField key={`${id}-subGeographic`} hidden id={`id`} name={"id"} value={id} {...register(`countries.${index}.id`)} />*/}
                                                    {/*        <TextField key={`${id}-${name}-subGeographic`} hidden id={`name`} name={"name"} value={name} {...register(`countries.${index}.name`)} />*/}
                                                    {/*        <TextField key={`${id}-display-${shortName}-subGeographic`} hidden id={`shortName`} name={"shortName"} value={shortName} {...register(`countries.${index}.shortName`)} />*/}
                                                    {/*        <FormControlLabel componentsProps={{ typography: { fontSize: '14px' } }} control={<Checkbox sx={{*/}
                                                    {/*            borderRadius: 0, border: '2px solid #4C58B2', boxShadow: 0,*/}
                                                    {/*        }} defaultChecked={selected}  {...register(`countries.${index}.selected`)} />} key={id} label={shortName} onClick={() => setFilterModifiedFlag(true)} />*/}

                                                    {/*    </Box>*/}
                                                    {/*))}*/}
                                                </Box>
                                            ))}
                                        </Stack>
                                    </Stack>
                                </FormControl>
                                }
                            </Stack>

                            <FormControl fullWidth>
                                <Stack direction="row" sx={{ width: '100%' }}>
                                    {!(entity?.search_terms?.value?.loading || entity?.search_terms?.value?.error) &&
                                    <Stack direction="column" sx={{
                                        mb: 1, ml: 2,
                                        // borderLeft: '1px solid #7daad6'
                                        width: '100%'
                                    }}>
                                        <Stack sx={{ justifyContent: 'space-between', flexGrow: '1', gap: 1, ml: 2, mb: 2 }}>
                                            {/* <Typography component="h4" variant="h6" sx={{ fontSize: 16 }}> */}
                                            <Typography variant="body1" sx={{ fontWeight: 600, fontSize: 16, color: 'background.paper' }}>

                                                Therapeutic areas / MeSH terms
                                                <span style={{ color: '#e56565', fontSize: "12px" }}> (Multiple keywords can be seperated by comma)</span>
                                            </Typography>
                                        </Stack>
                                        <Stack sx={{ justifyContent: 'space-between', flexGrow: '1', ml: 2 }}>
                                            <TextField
                                                id="search_terms"
                                                name="search_terms"
                                                type="text"
                                                variant='outlined'
                                                color='primary'
                                                multiline
                                                fullWidth
                                                size="normal"
                                                rows={3}
                                                sx={{
                                                    mb: 1.5,
                                                    '& .MuiInputBase-root': {
                                                        height: 'auto',
                                                        width: '100%',
                                                        maxWidth: '96%'
                                                    },
                                                }}
                                                placeholder={"MeSH terms"}
                                                defaultValue={entity?.search_terms?.value}
                                                inputlabelprops={{ shrink: true }}
                                                {...register('search_terms.value')}
                                                onChange={(e) => {handleKeywordSearchTerm(e); setFilterModifiedFlag(true);}}
                                            />


                                        </Stack>
                                    </Stack>
                                    }

                                </Stack>

                            </FormControl>
                            <Stack direction="row" sx={{ flexGrow: '1', gap: 3, justifyContent: 'center' }}>
                                <Button variant="contained" disabled={!filterModifiedFlag} type="submit"
                                        startIcon={<SearchIcon />}
                                        sx={{ mb: 4 }}
                                >Search</Button>
                                <Button onClick={() => { resetDiscoveryFilter(); setFilterModifiedFlag(false); }}
                                        disabled={!filterModifiedFlag} variant="outlined"
                                        startIcon={<RefreshIcon />}>
                                    Reset
                                </Button>

                            </Stack>
                        </form>
                    </Stack>
                </Box>
                {/*</Fade>*/}
            </Modal>
        </React.Fragment>
    );
}
